function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatteryDark = function SvgBatteryDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 137.35 100.26"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.46 12.05h-15.94V1.78c0-1-.78-1.78-1.75-1.78h-12.66c-.96 0-1.75.78-1.75 1.78v10.27H38.17V1.78c0-1-.78-1.78-1.75-1.78H23.76c-.96 0-1.75.78-1.75 1.78v10.27H5.85C2.64 12.05 0 14.69 0 17.93v76.45c0 3.24 2.64 5.88 5.85 5.88h125.61a5.89 5.89 0 0 0 5.88-5.88V17.93a5.89 5.89 0 0 0-5.88-5.88",
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.43,
    height: 8.29,
    x: 17.67,
    y: 37.76,
    rx: 1.75,
    ry: 1.75,
    style: {
      fill: "#a8cf38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66 39.5v4.79c0 .97-.78 1.75-1.75 1.75h-5.4c-.51 0-.92.41-.92.92v5.4c0 .97-.78 1.75-1.75 1.75h-4.79c-.97 0-1.75-.78-1.75-1.75v-5.4c0-.51-.41-.92-.92-.92h-5.4c-.97 0-1.75-.78-1.75-1.75V39.5c0-.97.78-1.75 1.75-1.75h5.4c.51 0 .92-.41.92-.92v-5.4c0-.97.78-1.75 1.75-1.75h4.79c.97 0 1.75.78 1.75 1.75v5.4c0 .51.41.92.92.92h5.4c.97 0 1.75.78 1.75 1.75",
    style: {
      fill: "#be2426"
    }
  })));
};
export default SvgBatteryDark;